import React from "react";
import { captureGAEvent, gaPanelConfig } from "../../shared/helper";

export default function ShipingBanner() {
  const sendGAEvent = (event: string) => {
    captureGAEvent(event, event);
  };
  return (
    <>
      <div className="hidden md:block">
        <div
          className="container"
          style={{ marginTop: "12px", background: "white" }}
        >
          <div
            style={{ borderRadius: "25px" }}
            className="mx-auto p-6 md:p-8 lg:p-10 border-2"
          >
            <div className="mb-2 text-center">
              <h2
                style={{ fontSize: "38px", fontFamily: "sfprobold" }}
                className=" font-bold text-#301A55"
              >
                The Shiprocket App Store Edge
              </h2>
            </div>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "normal",
                textAlign: "center",
              }}
              className=" mb-8 text-base md:text-lg lg:text-xl font-normal text-gray-700"
            >
              Shiprocket delivers the essentials your e-commerce needs. For all
              else, discover our app store.
            </p>
            {/* Three columns */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-10">
              <div className="mb-8 md:mb-0">
                <img
                  className="h-12 w-10 md:h-16 md:w-12"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677042_file.png"}
                  alt="App World"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl text-#301A55"
                  >
                    A World of Apps at Your Fingertips
                  </h3>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "justify",
                    }}
                    className="mt-2 text-xl text-gray-700 "
                  >
                    Choose from a multitude of apps to customize and enhance
                    your online store, tailored for the unique needs of
                    e-commerce logistics.
                  </p>
                </div>
              </div>

              <div className="mb-8 md:mb-0">
                <img
                  className="h-12 w-10 md:h-16 md:w-14"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677069_file.png"}
                  alt="Quality Assured Selection"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl  text-#301A55"
                  >
                    Quality Assured Selection
                  </h3>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "justify",
                    }}
                    className="mt-2 text-base text-gray-700"
                  >
                    Our apps undergo a rigorous multi-point inspection to ensure
                    quality and performance before they join the Shiprocket App
                    Store.
                  </p>
                </div>
              </div>

              <div>
                <img
                  className="h-12 w-10 md:h-16 md:w-12"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677134_file.png"}
                  alt="Data-Driven Recommendations"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl  text-#301A55"
                  >
                    Data-Driven Recommendations
                  </h3>
                  <p
                    style={{ fontSize: "14px", fontWeight: "normal" }}
                    className="mt-2 text-base text-gray-700"
                  >
                    Benefit from personalized app suggestions, driven by
                    successful use cases from a diverse range of e-commerce
                    ventures.
                  </p>
                </div>
              </div>
            </div>

            {/* Load More Button */}
            <div className="text-center">
              <button
      onClick={()=>{
        gaPanelConfig.BtnText = "Shipping Button";
        sendGAEvent("sras_start_shipping_button")
      }}
                style={{
                  background: "#735AE5",
                  border: "1px solid #00000000",
                  borderRadius: "8px",
                  opacity: 1,
                  padding: "10px 20px",
                  color: "#ffffff",
                  cursor: "pointer",
                  fontSize: "20px",
                  fontWeight: "300",
                  fontFamily: "sfprobold",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  width: "235px",
                }}
              >
                <a
                  href="https://app.shiprocket.in/seller/orders/new"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {"Let’s Start Shipping"}
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Second div - Show on mobile view */}
      <div className="block md:hidden m-5">
        <div
          className="container"
          style={{ marginTop: "12px", background: "white" }}
        >
          <div
            style={{ borderRadius: "25px" }}
            className="mx-auto p-6 md:p-8 lg:p-10 border-2"
          >
            <div className="mb-8 text-center">
              <h2
                style={{ fontSize: "38px", fontFamily: "sfprobold" }}
                className=" font-bold text-#301A55"
              >
                The Shiprocket App Store Edge
              </h2>
            </div>

            {/* Three columns */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-10">
              <p
                style={{ fontSize: "18px", fontWeight: "normal" }}
                className=" text-base md:text-lg lg:text-xl font-normal text-gray-700"
              >
                Shiprocket delivers the essentials your e-commerce needs. For
                all else, discover our app store.
              </p>
              <div className="mb-8 md:mb-0">
                <img
                  className="h-12 w-10 md:h-16 md:w-12"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677042_file.png"}
                  alt="App World"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl text-#301A55"
                  >
                    A World of Apps at Your Fingertips
                  </h3>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "justify",
                    }}
                    className="mt-2 text-xl text-gray-700 "
                  >
                    Choose from a multitude of apps to customize and enhance
                    your online store, tailored for the unique needs of
                    e-commerce logistics.
                  </p>
                </div>
              </div>

              <div className="mb-8 md:mb-0">
                <img
                  className="h-12 w-10 md:h-16 md:w-12"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677069_file.png"}
                  alt="Quality Assured Selection"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl  text-#301A55"
                  >
                    Quality Assured Selection
                  </h3>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "normal",
                      textAlign: "justify",
                    }}
                    className="mt-2 text-base text-gray-700"
                  >
                    Our apps undergo a rigorous multi-point inspection to ensure
                    quality and performance before they join the Shiprocket App
                    Store.
                  </p>
                </div>
              </div>

              <div>
                <img
                  className="h-12 w-10 md:h-16 md:w-12"
                  src={"https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727677134_file.png"}
                  alt="Data-Driven Recommendations"
                />
                <div className="mt-4 text-left">
                  <h3
                    style={{ fontSize: "18px", fontFamily: "sfprobold" }}
                    className="text-lg md:text-xl  text-#301A55"
                  >
                    Data-Driven Recommendations
                  </h3>
                  <p
                    style={{ fontSize: "14px", fontWeight: "normal" }}
                    className="mt-2 text-base text-gray-700"
                  >
                    Benefit from personalized app suggestions, driven by
                    successful use cases from a diverse range of e-commerce
                    ventures.
                  </p>
                </div>
              </div>
            </div>

            {/* Load More Button */}
            <div className="text-center">
              <button
                 onClick={()=>{
                  gaPanelConfig.BtnText = "Shipping Button";
                  sendGAEvent("sras_start_shipping_button")
                }}
                style={{
                  background: "#735AE5",
                  border: "1px solid #00000000",
                  borderRadius: "8px",
                  opacity: 1,
                  padding: "10px 20px",
                  color: "#ffffff",
                  cursor: "pointer",
                  fontSize: "20px",
                  fontWeight: "300",
                  fontFamily: "sfprobold",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  width: "235px",
                }}
              >
                <a
                  href="https://app.shiprocket.in/seller/orders/new"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  {"Let’s Start Shipping"}
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
